import { get } from "lodash";

import { FormValues, ParseForServerResultIProps } from "./schema/types";

export const mapToOptions = <TData>(data: TData | undefined, isEn: boolean) => {
  const path = `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`;
  const items = get(data, path, []) as string[];
  return items.map((el) => ({ label: el, value: el }));
};

export const parseForServer = (
  data: FormValues,
): ParseForServerResultIProps => {
  const { dealerSelect, startDate, endDate, selectFrom, groupBy } = data;
  const type = selectFrom?.value;

  const dataParse: ParseForServerResultIProps = {
    startDate,
    endDate,
    dealerGroup: {},
  };

  if (groupBy) {
    dataParse.groupBy = groupBy;
  }

  const values = Array.isArray(dealerSelect)
    ? dealerSelect
    : dealerSelect
      ? [dealerSelect]
      : [];

  const stringValues = values.map((item) => String(item.value));

  switch (type) {
    case "city":
      dataParse.dealerGroup!.cities = stringValues;
      break;
    case "subject":
      dataParse.dealerGroup!.subjects = stringValues;
      break;
    case "FO":
      dataParse.dealerGroup!.FOs = stringValues;
      break;
    case "country":
      dataParse.dealerGroup!.countries = stringValues;
      break;
    default:
      dataParse.dealerGroup = {
        ids: values.map((item) => Number(item.value)),
      };
      break;
  }

  return dataParse;
};
